module.exports = __webpack_public_path__ + "img/Frame 1103hrp-m1.f6efc771.png";